import { useEffect, useState } from "react";

export type Libphonenumber = typeof import("libphonenumber-js");

let libModule: Libphonenumber | null = null;
let libPromise: Promise<Libphonenumber> | null = null;

function loadLib(): Promise<Libphonenumber> {
	if (libModule) {
		return Promise.resolve(libModule);
	}
	if (!libPromise) {
		libPromise = import("libphonenumber-js")
			.then((loaded) => {
				libModule = loaded;
				return loaded;
			})
			.catch((error) => {
				// Clear so a subsequent mount can retry (e.g. transient network failure)
				libPromise = null;
				throw error;
			});
	}
	return libPromise;
}

export function useLibPhoneNumber(): Libphonenumber | null {
	const [lib, setLib] = useState<Libphonenumber | null>(libModule);

	useEffect(() => {
		if (lib) {
			return;
		}
		let mounted = true;
		loadLib()
			.then((loaded) => {
				if (mounted) {
					setLib(loaded);
				}
			})
			.catch(() => {
				// Swallow: fallback UI stays in disabled state
			});
		return () => {
			mounted = false;
		};
	}, [lib]);

	return lib;
}
